import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import styles from './Form.module.scss';

export interface Props extends ButtonProps {}

export default function FormButton(props: Props) {
  return <Button {...props} className={styles.formButton} />;
}
